export default __webpack_public_path__ + "static/Aeonik-RegularItalic-a86949321979ec66472d41afc7a571d1.otf";